import { render } from "./CmsConsole.vue?vue&type=template&id=97d725d6&scoped=true"
import script from "./CmsConsole.vue?vue&type=script&lang=js"
export * from "./CmsConsole.vue?vue&type=script&lang=js"

import "./CmsConsole.vue?vue&type=style&index=0&id=97d725d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d725d6"]])

export default __exports__